// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"483":"3f6dfe33","787":"a935ec5d"}[chunkId] + ".chunk.js";
};